module.exports = __webpack_public_path__ + "asset/img/img_hos_emp@2x.48401044.png";